import _ from 'lodash';
import defaultState from './defaultState';
import mutations from './mutations';

const state = _.cloneDeep(defaultState);

export default {
    namespaced: true,
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/appearance/store.js